/* eslint-disable no-case-declarations */
/* eslint-disable no-param-reassign */
import React from 'react';
import { filter, find } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';

import config from '../../../../../../config';
import { ClubMemberCardTypes } from '../../../../cards/ClubMemberCard';
import MembersHeader from './MembersHeader';
import { comparator, ComparatorTypes } from '../../../../../utils/comparator';
import { getRatingDetails, setRatingChoice } from '../../../../../utils';
import { SortType } from '../../../../ColumnHeader';
import { ClubMemberCard } from '../../../../cards';
import CheckboxSA from '../../../../FormElementsStandalone/CheckboxSA';

// import styles from '../../../../../pages/ClubProfiles/club.scss';

const _ = { filter, find };

class MembersList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.getMembersList = this.getMembersList.bind(this);
        this.getSortValue = this.getSortValue.bind(this);
        this.getComparatorType = this.getComparatorType.bind(this);
        this.onMenuSelected = this.onMenuSelected.bind(this);
    }

    onMenuSelected(option, member) {
        const {
            clubDetails,
        } = this.props;

        switch (member.type) {
            case ClubMemberCardTypes.INVITE:
                if (option.value === 'resend_invite') {
                    this.props.resendInvite('resend', clubDetails.id, member.item);
                } else {
                    this.props.deleteInvite('delete', clubDetails.id, member.item);
                }
                break;
            case ClubMemberCardTypes.MEMBER:
            case ClubMemberCardTypes.FORMER_MEMBER:
            default:
                if (option.value === 'make_owner' && clubDetails.availableOwnerSlots === 0) {
                    this.props.showOrganizerLimitPopup('Head Providers');
                    return;
                }
                if (option.value === 'make_admin' && clubDetails.availableAdminSlots === 0) {
                    this.props.showOrganizerLimitPopup('Providers');
                    return;
                }
                if (option.convertRoleTo) {
                    this.props.updateMemberRole(member.item.memberId, option.convertRoleTo);
                }
                if (option.memberTypeOption) {
                    this.props.updateMemberType(member.item.memberId, option.convertToPhysicalMember);
                }
                if (option.memberPowerOption) {
                    if (option.currentPowerOption || clubDetails.maxPowerUsers - clubDetails.currentPowerUsers > 0) {
                        this.props.updateClubMemberPower(member.item.memberId, !option.currentPowerOption);
                    } else {
                        this.props.showError(`You have used your ${clubDetails.maxPowerUsers} Power subscriptions for your club members. Please contact your account administrator or our <a href="https://support.${config.siteBaseUrl}/support/tickets/new" target="_blank">Support Team</a> to purchase more subscriptions.`);
                    }
                }
                break;
        }
    }

    getMembersList() {
        const {
            isAdminOrOwner,
            showMembershipType,
            showBillingType,
            clubDetails,
            membersTabState,
            selectedMembers,
        } = this.props;

        const {
            memberViewType,
            adminViewType,
            requestViewType,
            inviteViewType,
            sortParam,
            sortType,
        } = membersTabState;

        const {
            clubMembers,
            clubOrganizers,
            formerClubMembers,
            clubMemberRequests,
            clubMemberInvites,
            canHaveMultipleOwners,
            canHaveMultipleAdmins,
            isEnterprise,
            currentMember,
            isPremium,
            isProCollege,
        } = clubDetails;

        const currentMemberRole = currentMember && currentMember.role;
        const ownersCount = _.filter(clubOrganizers, { role: 'Owner' }).length;
        const selectedMemberCount = selectedMembers.filter(e => e).length;
        const membersToDisplay = [];
        switch (adminViewType) {
            case 'members':
                if (memberViewType === 'current') {
                    const options = [
                        {
                            label: 'Make Head Provider',
                            value: 'make_owner',
                            currentMember: ['Owner'],
                            memberRole: ['Admin', 'Member'],
                            convertRoleTo: 'Owner',
                        },
                        {
                            label: 'Make Provider',
                            value: 'make_admin',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['Member'],
                            convertRoleTo: 'Admin',
                        },
                        ...(selectedMemberCount ? [] : [{
                            label: 'Remove Member',
                            value: 'remove_member_by_owner',
                            currentMember: ['Owner'],
                            memberRole: ['Admin', 'Member'],
                            convertRoleTo: 'FormerMember',
                        }]),
                        ...(selectedMemberCount ? [] : [{
                            label: 'Remove Member',
                            value: 'remove_member_by_admin',
                            currentMember: ['Admin'],
                            memberRole: ['Member'],
                            convertRoleTo: 'FormerMember',
                        }]),
                        {
                            label: 'Remove Provider privileges',
                            value: 'remove_admin_privilages',
                            currentMember: ['Owner'],
                            memberRole: ['Owner', 'Admin'],
                            convertRoleTo: 'Member',
                        },
                        ...(selectedMemberCount ? [] : [{
                            label: 'Change to Physical Member',
                            value: 'change_to_physical_member',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['Owner', 'Admin', 'Member'],
                            memberTypeOption: true,
                            currentMemberTypeId: 2,
                            convertToPhysicalMember: true,
                        }]),
                        ...(selectedMemberCount ? [] : [{
                            label: 'Change to Digital Member',
                            value: 'change_to_digital_member',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['Owner', 'Admin', 'Member'],
                            memberTypeOption: true,
                            currentMemberTypeId: 1,
                            convertToPhysicalMember: false,
                        }]),
                        {
                            label: 'Add to Power (Club)',
                            value: 'add_to_power_club',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['Owner', 'Admin', 'Member'],
                            memberPowerOption: true,
                            currentPowerOption: false,
                        },
                        {
                            label: 'Remove From Power (Club)',
                            value: 'remove_from_power_club',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['Owner', 'Admin', 'Member'],
                            memberPowerOption: true,
                            currentPowerOption: true,
                        },
                        {
                            label: 'Make Member',
                            value: 'make_follower_member',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['Follower'],
                            convertRoleTo: 'Member',
                        },
                        {
                            label: 'Remove Follower',
                            value: 'remove_follower',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['Follower'],
                            convertRoleTo: 'FormerFollower',
                        },
                    ];
                    if (clubMembers && clubMembers.length) {
                        clubMembers.forEach((member) => {
                            const optionsToDisplay = [];
                            if (isAdminOrOwner) {
                                options.forEach((option) => {
                                    const canDisplayOption = option.currentMember.includes(currentMemberRole) && option.memberRole.includes(member.role) && (option.memberTypeOption ? showMembershipType && (option.currentMemberTypeId === member.clubMemberTypeId) : true) &&
                                        (option.memberPowerOption ? showBillingType && (option.currentPowerOption === member.isPower) : true);
                                    if (canDisplayOption) {
                                        if (member.role === 'Owner' && option.value === 'remove_admin_privilages') {
                                            if (canHaveMultipleOwners) {
                                                if (ownersCount > 1) {
                                                    optionsToDisplay.push(option);
                                                } else {
                                                    optionsToDisplay.push({
                                                        label: 'You must add someone else as a Head Provider before changing this role',
                                                        value: 'no_permission',
                                                    });
                                                }
                                            } else {
                                                optionsToDisplay.push({
                                                    label: 'You cannot change this role in a personal club',
                                                    value: 'no_permission',
                                                });
                                            }
                                        } else if (option.value === 'make_owner') {
                                            if (canHaveMultipleOwners) {
                                                optionsToDisplay.push(option);
                                            }
                                        } else if (option.value === 'make_admin') {
                                            if (canHaveMultipleAdmins) {
                                                optionsToDisplay.push(option);
                                            }
                                        } else if (option.value === 'add_to_power_club') {
                                            if (isEnterprise || isPremium || isProCollege) {
                                                optionsToDisplay.push(option);
                                            }
                                        } else {
                                            optionsToDisplay.push(option);
                                        }
                                    }
                                });
                                if (optionsToDisplay.length === 0) {
                                    optionsToDisplay.push({
                                        label: 'You dont have permission to change member role',
                                        value: 'no_permission',
                                    });
                                }
                            }
                            const object = {};
                            object.type = ClubMemberCardTypes.MEMBER;
                            object.item = member;
                            object.options = optionsToDisplay;
                            membersToDisplay.push(object);
                        });
                    }
                } else if (memberViewType === 'former') {
                    const options = [
                        {
                            label: 'Make Member',
                            value: 'make_member',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['FormerMember'],
                            convertRoleTo: 'Member',
                        },
                        {
                            label: 'Make Follower',
                            value: 'make_follower',
                            currentMember: ['Owner', 'Admin'],
                            memberRole: ['FormerFollower'],
                            convertRoleTo: 'Follower',
                        },
                    ];
                    // eslint-disable-next-line no-unused-expressions
                    formerClubMembers && formerClubMembers.forEach((member) => {
                        const optionsToDisplay = [];
                        if (isAdminOrOwner) {
                            options.forEach((option) => {
                                const canDisplayOption = option.currentMember.includes(currentMemberRole) && option.memberRole.includes(member.role);
                                if (canDisplayOption) {
                                    optionsToDisplay.push(option);
                                }
                            });
                        }
                        const object = {};
                        object.type = ClubMemberCardTypes.FORMER_MEMBER;
                        object.item = member;
                        object.options = isAdminOrOwner ? optionsToDisplay : [];
                        membersToDisplay.push(object);
                    });
                }
                break;
            case 'requests':
                clubMemberRequests.forEach((request) => {
                    if (request.status === requestViewType) {
                        const object = {};
                        const item = this.convertRequestToMember(request);
                        object.type = ClubMemberCardTypes.REQUEST;
                        object.item = item;
                        membersToDisplay.push(object);
                    }
                });
                break;
            case 'invites':
                const options = [
                    {
                        label: 'Resend Invite',
                        value: 'resend_invite',
                        currentMember: ['Owner', 'Admin'],
                    },
                    {
                        label: 'Delete Invite',
                        value: 'Delete_invite',
                        currentMember: ['Owner', 'Admin'],
                    },
                ];
                if (clubMemberInvites && clubMemberInvites.length) {
                    clubMemberInvites.forEach((invite) => {
                        if (invite.status === inviteViewType) {
                            const optionsToDisplay = [];
                            if (isAdminOrOwner) {
                                options.forEach((option) => {
                                    const canDisplayOption = option.currentMember.includes(currentMemberRole);
                                    if (canDisplayOption) {
                                        optionsToDisplay.push(option);
                                    }
                                });
                            }

                            const object = {};
                            const item = this.convertInviteToMember(invite);
                            object.type = ClubMemberCardTypes.INVITE;
                            object.item = item;
                            object.options = isAdminOrOwner ? optionsToDisplay : [];
                            membersToDisplay.push(object);
                        }
                    });
                }
                break;

            default:
                break;
        }
        membersToDisplay.forEach((member) => {
            switch (sortParam) {
                case 'name':
                    member.primarySortValue = this.getSortValue(member.item, 'lastName');
                    member.secondarySortValue = this.getSortValue(member.item, 'firstName');
                    break;
                case 'membershipType':
                    member.primarySortValue = this.getSortValue(member.item, 'status');
                    member.secondarySortValue = this.getSortValue(member.item, 'membershipType');
                    break;
                case 'singlesRating':
                    member.primarySortValue = this.getSortValue(member.item, 'ratingChoiceSingles');
                    member.secondarySortValue = this.getSortValue(member.item, 'singlesRating');
                    break;
                case 'doublesRating':
                    member.primarySortValue = this.getSortValue(member.item, 'ratingChoiceDoubles');
                    member.secondarySortValue = this.getSortValue(member.item, 'doublesRating');
                    break;
                default:
                    member.primarySortValue = this.getSortValue(member.item, sortParam);
                    break;
            }
        });
        membersToDisplay.sort(comparator(this.getComparatorArguments(sortParam, sortType)));
        return membersToDisplay;
    }

    getSortValue(member, sortParam) {
        const {
            clubMemberRoles,
            userIsPowered,
        } = this.props;
        switch (sortParam) {
            case 'singlesRating':
                const singlesRating = getRatingDetails(setRatingChoice({ player: member, ratingType: 'singles' }), userIsPowered);
                return singlesRating.actualValue;
            case 'doublesRating':
                const doublesRating = getRatingDetails(setRatingChoice({ player: member, ratingType: 'doubles' }), userIsPowered);
                return doublesRating.actualValue;
            case 'date':
                return moment(member.intialJoinDate);
            case 'status':
                const roleObject = _.find(clubMemberRoles, { value: member.role });
                return roleObject ? roleObject.id : 0;
            case 'membershipType':
                return member.clubMemberTypeId || 0;
            case 'billingStatus':
                return member.isPower ? 1 : 0;
            case 'ratingChoiceSingles':
                const ratingSingles = getRatingDetails(setRatingChoice({ player: member, ratingType: 'singles' }), userIsPowered);
                return ratingSingles.sortValue;
            case 'ratingChoiceDoubles':
                const ratingDoubles = getRatingDetails(setRatingChoice({ player: member, ratingType: 'doubles' }), userIsPowered);
                return ratingDoubles.sortValue;
            default:
                return member[sortParam];
        }
    }

    getComparatorType(sortParam) {
        switch (sortParam) {
            case 'date':
                return ComparatorTypes.DATE;
            case 'singlesRating':
            case 'doublesRating':
            case 'status':
            case 'membershipType':
            case 'billingStatus':
            case 'ratingChoiceSingles':
            case 'ratingChoiceDoubles':
                return ComparatorTypes.NUMBER;
            default:
                return ComparatorTypes.STRING;
        }
    }

    getComparatorArguments(sortParam, sortType) {
        const args = [];
        const primaryArgs = ['singlesRating', 'doublesRating'];
        const secondArgs = ['name', 'membershipType', 'singlesRating', 'doublesRating'];
        const primaryDescend = (primaryArgs.includes(sortParam)) ? 'true' : (sortType === SortType.DESC);
        const primarySortArg = {
            type: this.getComparatorType(sortParam),
            field: 'primarySortValue',
            descend: primaryDescend,
        };
        args.push(primarySortArg);
        if (secondArgs.includes(sortParam)) {
            const seconfarySortArg = {
                type: this.getComparatorType(sortParam),
                field: 'secondarySortValue',
                descend: sortType === SortType.DESC,
            };
            args.push(seconfarySortArg);
        }
        return args;
    }

    convertRequestToMember(request) {
        if (request.status === 'Accepted' || request.status === 'Rejected') {
            request.intialJoinDate = request.acceptedRejectedDate;
        } else if (request.status === 'Pending') {
            request.intialJoinDate = request.requestedDate;
        }
        request.role = request.status;
        return request;
    }

    convertInviteToMember(invite) {
        if (invite.status === 'pending') {
            invite.intialJoinDate = invite.dateInvited;
        } else {
            invite.intialJoinDate = invite.dateAccepted;
        }
        invite.role = invite.status;
        if (!invite.firstName) {
            invite.firstName = invite.inviteeEmail;
        }
        return invite;
    }

    render() {
        const {
            isAdminOrOwner,
            showMembershipType,
            showBillingType,
            clubDetails,
            userIsPowered,
            membersTabState,
            isCollegeOrHighSchool,
            isCollege,
            auth,
            sendMessage,
            sortState,
            setSorting,
            filters,
            selectedMembers,
            onHeaderAllSelectChange,
            showCheckboxes,
        } = this.props;

        const membersToDisplay = this.getMembersList();

        const selectedMemberCount = selectedMembers.filter(e => e).length;
        // const { clubMembersTotal } = clubDetails;
        return (
            <div>
                <MembersHeader
                    membersTabState={membersTabState}
                    isAdminOrOwner={isAdminOrOwner}
                    isCollegeOrHighSchool={isCollegeOrHighSchool}
                    showBillingType={showBillingType}
                    showMembershipType={showMembershipType}
                    updateMembersTabState={this.props.updateMembersTabState}
                    clubDetails={clubDetails}
                    userIsPowered={userIsPowered}
                    isPersonal={this.props.isPersonal}
                    showUpgradeToPowerPopup={this.props.showUpgradeToPowerPopup}
                    sortState={sortState}
                    setSorting={setSorting}
                    filters={filters}
                    onHeaderAllSelectChange={onHeaderAllSelectChange}
                    headerAllSelected={selectedMemberCount === 20 || selectedMemberCount === membersToDisplay.length}
                    showCheckboxes={showCheckboxes}
                    auth={auth}
                    search={this.props.search}
                />
                {membersToDisplay && !!membersToDisplay.length && membersToDisplay.map((member, i) => {
                    const isCollegeCoach = isCollege && member.item && member.item.role && (member.item.role === 'Owner' || member.item.role === 'Admin');
                    return (
                        <div
                            className={`checkbox-card-wrapper ${isAdminOrOwner && showCheckboxes ? 'show-checkbox' : ''}`}
                            // eslint-disable-next-line react/no-array-index-key
                            key={`member-${i}`}
                        >
                            {isAdminOrOwner && showCheckboxes && (
                                <div className={`card-checkbox-wrapper d-none d-md-block`}>
                                    <CheckboxSA
                                        checked={selectedMembers[i]}
                                        onChange={() => this.props.onMemberSelected(i)}
                                    />
                                </div>
                            )}
                            <ClubMemberCard
                                member={member.item}
                                menuOptions={member.options}
                                menuOnSelected={(option) => {
                                    this.onMenuSelected(option, member);
                                }}
                                type={member.type}
                                userIsPowered={userIsPowered}
                                resendInvite={this.props.resendInvite}
                                approveOrRejectRequest={this.props.approveOrRejectRequest}
                                clubDetails={clubDetails}
                                showDecimals={isAdminOrOwner}
                                isAdminOrOwner={isAdminOrOwner}
                                hideMessageOption={isCollegeCoach}
                                auth={auth}
                                sendMessage={sendMessage}
                                selected={selectedMembers[i]}
                                filters={filters}
                                showProjectedViewStatus={true}
                                membersTabState={membersTabState}
                                showCheckboxes={showCheckboxes}
                                selectedMembers={selectedMembers}
                                onMemberSelected={this.props.onMemberSelected}
                                index={i}
                                data-testid={member.item?.memberId ? `club-profile.member-${member.item.memberId}` : undefined}
                            />
                        </div>
                    );
                })}
            </div>
        );
    }
}

MembersList.propTypes = {
    search: PropTypes.instanceOf(Object),
    onMemberSelected: PropTypes.func,
};

MembersList.defaultProps = {
    search: null,
    onMemberSelected: () => { },
};

export default MembersList;
